import { render, staticRenderFns } from "./GridNameEditor.vue?vue&type=template&id=86dbc8b4&scoped=true&"
import script from "./GridNameEditor.vue?vue&type=script&lang=js&"
export * from "./GridNameEditor.vue?vue&type=script&lang=js&"
import style0 from "./GridNameEditor.vue?vue&type=style&index=0&id=86dbc8b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86dbc8b4",
  null
  
)

export default component.exports